<template>
  <div class="card mb-4">
    <div class="col-12">
      <transition name="slide-fade">
        <subcourse-details
          v-if="isChildVisible"
          @close="hideSubcourseDetails"
          :subcourse="subcourse"
          :lastSeason="localLastSeason"
        />
      </transition>
      <transition name="slide-fade">
        <FormEditSubcourse
          v-if="isEditSubcourseVisible"
          @close-edit-form="hideEditSubcourse"
          :subcourse="subcourse"
        />
      </transition>
    </div>
    <div class="card-header pb-0">
      <h6>{{ $t("subcourses.subcourses") }}</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-3"
              >
                {{ $t("subcourses.subcourseTitle") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("subcourses.coursePrice") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("teachers.activ") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("subcourses.startFrom") }}
              </th>
              <th class="text-secondary opacity-7 col-2"></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("teachers.details") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in subcourses" :key="item.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.title }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="align-middle text-center text-sm">
                  <div class="d-flex flex-column justify-content-center">
                    {{ item.price }} {{ $t("global.currency") }}
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge
                  v-if="item.deleted_at == null"
                  color="success"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.yes") }}
                </soft-badge>
                <soft-badge
                  v-else
                  color="secondary"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.no") }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{
                  item.start_date
                }}</span>
              </td>
              <td class="align-middle text-center">
                <div v-if="lastSeason">
                  <div v-if="!item.deleted_at">
                    <a
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editSubcourse(item)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i
                      >{{ $t("global.edit") }}
                    </a>
                    <a
                      class="btn btn-link text-danger text-gradient px-3 mb-0"
                      href="javascript:;"
                      @click="deleteSubcourse(item)"
                    >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                      >{{ $t("global.delete") }}
                    </a>
                  </div>
                  <div v-else>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      class="mx-3"
                      @click="activateSubourse(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'success' : 'secondary'"
                        class="w-50"
                        variant="gradient"
                        size="sm"
                      >
                        {{ !item.valid ? $t("global.activate") : "" }}
                      </soft-badge>
                    </a>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      @click="permanentlyDeleteSubcourse(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'danger' : 'secondary'"
                        class="w-50"
                        variant="gradient"
                        size="sm"
                      >
                        {{ !item.valid ? $t("global.deleteForever") : "" }}
                      </soft-badge>
                    </a>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <a href="#" @click="showSubcourse(item)">
                  <soft-badge color="success" variant="gradient" size="sm">
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import SubcourseDetails from "../components/SubcourseDetails";
import FormEditSubcourse from "@/components/FormEditSubcourse.vue";
import swal from "sweetalert2";
import axios from "axios";

export default {
  name: "subcourse-list",
  props: {
    subcourses: {
      type: Array,
      required: true,
      default: () => [],
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
    isEditFormVisible: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    SoftBadge,
    SubcourseDetails,
    FormEditSubcourse,
  },
  data() {
    return {
      subcourse: {},
      isEditSubcourseVisible: false,
      isChildVisible: false,
    };
  },
  watch: {
    isEditFormVisible(new_value) {
      this.isEditSubcourseVisible = new_value;
    },
    subcourses() {
      this.localLastSeason = this.$route.params.lastSeason
        ? this.$route.params.lastSeason
        : this.lastSeason;
    },
  },
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
  },
  methods: {
    editSubcourse(subcourse) {
      this.subcourse = subcourse;
      this.isEditSubcourseVisible = true;
      this.$emit("hide-create-form");
    },
    async deleteSubcourse(subcourse) {
      const test = await axios.get("check-subcourses-kids/" + subcourse.id);
      let optionalText = "";
      test.data.kids.forEach(
        (item) => (optionalText += "<br>- " + item.kid_name + ", ")
      );
      let text =
        optionalText != ""
          ? this.$t("subcourses.checkKids") + optionalText
          : "";
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        html: text,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("subcourse/" + subcourse.id);
          swal.fire({
            icon: "success",
            title: this.$t(response.data.message),
            showConfirmButton: true,
          });
          this.$emit("fetch-subcourses");
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    showSubcourse(subcourse) {
      this.subcourse = subcourse;
      this.isChildVisible = true;
      this.scrollToTop();
    },
    hideChild() {
      this.isChildVisible = false;
    },
    hideSubcourseDetails() {
      this.isChildVisible = false;
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    hideEditSubcourse() {
      this.isEditSubcourseVisible = false;
      this.$emit("form-submitted");
    },

    async activateSubourse(subcourse) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (!subcourse.course || subcourse.course.deleted_at) {
        swal.fire({
          title: this.$t("global.error") + "!",
          text: this.$t("subcourses.courseDeleted"),
          icon: "error",
        });
        return;
      }
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.post("activate-subcourse", {
            subcourse: subcourse.id,
          });
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-subcourses");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.close();
        swal.fire({
          title: this.$t("global.activationCancelled"),
          text: "",
          icon: "success",
        });
      }
      this.$emit("close-edit-subcourse");
    },
    async permanentlyDeleteSubcourse(subcourse) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: this.$t("subcourses.subcoursePermanentlyDelete"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.delete(
            "permanently-delete-subcourse/" + subcourse.id
          );
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-subcourses");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
  },
};
</script>
